import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FaLocationDot } from "react-icons/fa6";
import Layout from "../Layout";
import MapWithSearch from "../components/HfrRegister/MapWithSearch";
import MapRegister from "../components/HfrRegister/MapRegister";
import axios from "axios";
import { BaseUrl } from "../BaseUrl";

export default function HfrRegisterUI({ setStep, formData = {}, setFormData }) {
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorFacilityName, setErrorFacilityName] = useState("");
  const [errorCountry, setErrorCountry] = useState("");
  const [errorState, setErrorState] = useState("");
  const [errorMobile, setErrorMobile] = useState("");
  const [countries, setCountries] = useState([]); // New state for countries

  // Initialize local form data if props are undefined
//   const facilityInformation = formData.facilityInformation || {
//   facilityName: "Sunrise Health Clinic",
//   facilityAddressDetails: {
//     country: "India",
//     stateLGDCode: "19",       // West Bengal
//     districtLGDCode: "334",  // Kolkata
//     subDistrictLGDCode: "102",
//     facilityRegion: "Urban",
//     villageCityTownLGDCode: "700001",
//     addressLine1: "123 Park Street",
//     addressLine2: "Near City Mall",
//     pincode: "700016",
//   },
//   facilityContactInformation: {
//     facilityEmailId: "contact@sunriseclinic.in",
//     facilityContactNumber: "+91-9876543210",
//     websiteLink: "https://sunriseclinic.in",
//     facilityLandlineNumber: "033-22223333",
//     facilityStdCode: "033",
//     appointmentLink: "https://sunriseclinic.in/book-appointment",
//   },
// };
  const facilityInformation = formData.facilityInformation || {
    facilityName: "",
    facilityAddressDetails: {
      country: "",
      stateLGDCode: "",
      districtLGDCode: "",
      subDistrictLGDCode: "",
      facilityRegion: "",
      villageCityTownLGDCode: "",
      addressLine1: "",
      addressLine2: "",
      pincode: "",
    },
    facilityContactInformation: {
      facilityEmailId: "",
      facilityContactNumber: "",
      websiteLink: "",
      facilityLandlineNumber: "",
      facilityStdCode: "",
      appointmentLink: "",
    },
  };
  const onlyLettersRegex = /^[A-Za-z\s]+$/;
  const facilityNameRegex = /^[A-Za-z][A-Za-z0-9 ]{4,}$/;
  const phoneRegex = /^[6-9]\d{9}$/;

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${BaseUrl}/doctor/countries`
        );

        if (response.data.success) {
          setCountries(response.data.data);
        } else {
          setError("Failed to load countries");
        }
      } catch (err) {
        setError("Error fetching countries");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);
  useEffect(() => {
  if (!facilityInformation.facilityAddressDetails.country) {
    setFormData((prev) => ({
      ...prev,
      facilityInformation: {
        ...prev.facilityInformation,
        facilityAddressDetails: {
          ...prev.facilityInformation?.facilityAddressDetails,
          country: "India",
        },
      },
    }));
  }
}, []); 


  // Fetch states on component mount
  useEffect(() => {
    const fetchStates = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${BaseUrl}/doctor/states`
        );
        if (response.data.success) {
          setStates(response.data.data);
        } else {
          setError("Failed to load states");
        }
      } catch (err) {
        setError("Error fetching states");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchStates();
  }, []);

  // Fetch districts when a state is selected
  useEffect(() => {
    if (facilityInformation.facilityAddressDetails.stateLGDCode) {
      const fetchDistricts = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `${BaseUrl}/doctor/districts/${
              facilityInformation.facilityAddressDetails.stateLGDCode
            }`
          );
          if (response.data.success) {
            setDistricts(response.data.data);
            setFormData((prev) => ({
              ...prev,
              facilityInformation: {
                ...prev.facilityInformation,
                facilityAddressDetails: {
                  ...prev.facilityInformation?.facilityAddressDetails,
                  districtLGDCode: "",
                  subDistrictLGDCode: "",
                },
              },
            }));
            setSubDistricts([]);
          } else {
            setError("Failed to load districts");
          }
        } catch (err) {
          setError("Error fetching districts");
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      fetchDistricts();
    } else {
      setDistricts([]);
      setSubDistricts([]);
    }
  }, [facilityInformation.facilityAddressDetails.stateLGDCode, setFormData]);

  // Fetch sub-districts when a district is selected
  useEffect(() => {
    if (facilityInformation.facilityAddressDetails.districtLGDCode) {
      const fetchSubDistricts = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `${BaseUrl}/doctor/hfr/get-lgd-sub-districts/${
              facilityInformation.facilityAddressDetails.districtLGDCode
            }`
          );

          if (response.data.success) {
            setSubDistricts(response.data.data);
            setFormData((prev) => ({
              ...prev,
              facilityInformation: {
                ...prev.facilityInformation,
                facilityAddressDetails: {
                  ...prev.facilityInformation?.facilityAddressDetails,
                  subDistrictLGDCode: "",
                },
              },
            }));
          } else {
            setError("Failed to load sub-districts");
          }
        } catch (err) {
          setError("Error fetching sub-districts");
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      fetchSubDistricts();
    } else {
      setSubDistricts([]);
    }
  }, [facilityInformation.facilityAddressDetails.districtLGDCode, setFormData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "facilityContactNumber") {
      if (!/^\d*$/.test(value)) return; // only digits allowed
      setErrorMobile("");
    }

    if (name in facilityInformation.facilityAddressDetails) {
      setFormData((prev) => ({
        ...prev,
        facilityInformation: {
          ...prev.facilityInformation,
          facilityAddressDetails: {
            ...prev.facilityInformation?.facilityAddressDetails,
            [name]: value,
          },
        },
      }));
    } else if (name in facilityInformation.facilityContactInformation) {
      setFormData((prev) => ({
        ...prev,
        facilityInformation: {
          ...prev.facilityInformation,
          facilityContactInformation: {
            ...prev.facilityInformation?.facilityContactInformation,
            [name]: value,
          },
        },
      }));
    } else if (name === "facilityName") {
      setFormData((prev) => ({
        ...prev,
        facilityInformation: {
          ...prev.facilityInformation,
          facilityName: value,
        },
      }));

      if (value && !facilityNameRegex.test(value)) {
        setErrorFacilityName(
          "Facility name must start with a letter, contain only letters & numbers, and be at least 5 characters."
        );
      } else {
        setErrorFacilityName("");
      }
    }
  };

  const handleNext = () => {
    let hasError = false;
    if (!facilityInformation.facilityName.trim()) {
      setErrorFacilityName("Facility Name is required.");
      hasError = true;
    } else if (!facilityNameRegex.test(facilityInformation.facilityName)) {
      setErrorFacilityName(
        "Facility name must contain only letters and be at least 5 characters."
      );
      hasError = true;
    } else {
      setErrorFacilityName("");
    }

    // Country check
    if (!facilityInformation.facilityAddressDetails.country.trim()) {
      setErrorCountry("Country is required.");
      hasError = true;
    } else if (
      !onlyLettersRegex.test(facilityInformation.facilityAddressDetails.country)
    ) {
      setErrorCountry("Country cannot contain numbers.");
      hasError = true;
    } else {
      setErrorCountry("");
    }

    // State check
    if (!facilityInformation.facilityAddressDetails.stateLGDCode.trim()) {
      setErrorState("State is required.");
      hasError = true;
    } else {
      setErrorState("");
    }

    // Mobile number check
    if (
      !facilityInformation.facilityContactInformation.facilityContactNumber.trim()
    ) {
      setErrorMobile("Mobile number is required.");
      hasError = true;
    } else if (
      !phoneRegex.test(
        facilityInformation.facilityContactInformation.facilityContactNumber
      )
    ) {
      setErrorMobile("Enter a valid 10-digit mobile number starting with 6-9.");
      hasError = true;
    } else {
      setErrorState("");
    }

    if (!hasError) {
      setStep(2);
    }
  };

  return (
    <div className='bg-white'>
      <Layout>
        <div className='mb-6 flex justify-center'>
          <div className='flex items-center gap-4 text-sm font-semibold'>
            <div className='flex h-6 w-6 items-center justify-center rounded-full bg-blue-500 text-white'>
              1
            </div>
            <span className='text-blue-500'>Facility Registration Form</span>
            <div className='h-1 w-8 bg-blue-500' />
            <div className='flex h-6 w-6 items-center justify-center rounded-full bg-gray-300 text-gray-500'>
              2
            </div>
            <span className='text-gray-500'>Detailed Facility Information</span>
            <div className='h-1 w-8 bg-gray-300' />
            <div className='flex h-6 w-6 items-center justify-center rounded-full bg-gray-300 text-gray-500'>
              3
            </div>
            <span className='text-gray-500'>Preview Profile</span>
          </div>
        </div>

        {error && <div className='mb-4 text-sm text-red-500'>{error}</div>}

        <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Input
              label='Facility Name'
              name='facilityName'
              value={facilityInformation.facilityName}
              onChange={handleChange}
              required
            />
            {errorFacilityName && (
              <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                {errorFacilityName}
              </p>
            )}
          </div>
          {/*country */}

          <div className='flex flex-col'>
            {/* <Input
              label="Country"
              name="country"
              value={facilityInformation.facilityAddressDetails.country}
              onChange={handleChange}
              required
            /> */}
            <label className='mb-1 text-sm text-gray-600'>
              Country <span className='text-red-500'>*</span>
            </label>

            <select
              name='country'
              value={facilityInformation.facilityAddressDetails.country}
              onChange={handleChange}
              className='rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
              required
            >
              <option value=''>Select Country</option>
              {countries.map((country) => (
                <option key={country.id} value={country.enShortName}>
                  {country.enShortName}
                </option>
              ))}
            </select>
            {errorCountry && (
              <p className='mt-1 text-sm text-red-500'>{errorCountry}</p>
            )}
          </div>

          {/* State */}
          <div className='flex flex-col'>
            <label className='mb-1 text-sm text-gray-600'>
              State / UT <span className='text-red-500'>*</span>
            </label>
            {/* <input
              type="text"
              name="stateLGDCode"
              value={facilityInformation.facilityAddressDetails.stateLGDCode}
              onChange={handleChange}
              className="rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            /> */}

            <select
              name='stateLGDCode'
              value={facilityInformation.facilityAddressDetails.stateLGDCode}
              onChange={handleChange}
              className='rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
              required
            >
              <option value=''>Select State</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </select>
            {errorState && (
              <p className='mt-1 text-sm text-red-500'>{errorState}</p>
            )}
          </div>

          <div className='flex flex-col'>
            <label className='mb-1 text-sm text-gray-600'>District</label>
            <select
              name='districtLGDCode'
              value={facilityInformation.facilityAddressDetails.districtLGDCode}
              onChange={handleChange}
              className='rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
              disabled={
                loading ||
                !facilityInformation.facilityAddressDetails.stateLGDCode
              }
            >
              <option value=''>Select District</option>
              {districts.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.districtName}
                </option>
              ))}
            </select>
          </div>
          <div className='flex flex-col'>
            <label className='mb-1 text-sm text-gray-600'>Sub-District</label>
            <select
              name='subDistrictLGDCode'
              value={
                facilityInformation.facilityAddressDetails.subDistrictLGDCode
              }
              onChange={handleChange}
              className='rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
              disabled={
                loading ||
                !facilityInformation.facilityAddressDetails.districtLGDCode
              }
            >
              <option value=''>Select Sub-District</option>
              {subDistricts.map((subDistrict) => (
                <option key={subDistrict.code} value={subDistrict.code}>
                  {subDistrict.name}
                </option>
              ))}
            </select>
          </div>
          <div className='flex flex-col'>
            <label className='mb-1 text-sm text-gray-600'>
              Facility Region
            </label>
            <select
              name='facilityRegion'
              value={facilityInformation.facilityAddressDetails.facilityRegion}
              onChange={handleChange}
              className='rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            >
              <option value=''>Select Region</option>
              <option value='U'>Urban</option>
              <option value='R'>Rural</option>
            </select>
          </div>
          <Input
            label='Village / City / Town'
            name='villageCityTownLGDCode'
            value={
              facilityInformation.facilityAddressDetails.villageCityTownLGDCode
            }
            onChange={handleChange}
          />
          <Input
            label='Address No 1'
            name='addressLine1'
            value={facilityInformation.facilityAddressDetails.addressLine1}
            onChange={handleChange}
          />
          <Input
            label='Address No 2'
            name='addressLine2'
            value={facilityInformation.facilityAddressDetails.addressLine2}
            onChange={handleChange}
          />
          <Input
            label='Pin Code'
            name='pincode'
            value={facilityInformation.facilityAddressDetails.pincode}
            onChange={handleChange}
          />
          <Input
            label='Landline Number'
            name='facilityLandlineNumber'
            value={
              facilityInformation.facilityContactInformation
                .facilityLandlineNumber
            }
            onChange={handleChange}
          />
          <div className='flex flex-col'>
            <label className='mb-1 text-sm text-gray-600'>
              Mobile Number (For Public Display)
              <span className='text-red-500'>*</span>
            </label>
            <div className='flex'>
              <input
                type='text'
                name='facilityContactNumber'
                value={
                  facilityInformation.facilityContactInformation
                    .facilityContactNumber
                }
                onChange={handleChange}
                maxLength={10}
                // className="rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
                className='flex-1 rounded-l border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
              />
              <button className='rounded-r bg-blue-500 px-4 text-sm text-white'>
                Verify
              </button>
            </div>
          </div>
          <div className='flex flex-col'>
            <label className='mb-1 text-sm text-gray-600'>
              Facility Email (For Public Display)
            </label>
            <div className='flex'>
              <input
                type='text'
                name='facilityEmailId'
                value={
                  facilityInformation.facilityContactInformation.facilityEmailId
                }
                onChange={handleChange}
                className='flex-1 rounded-l border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-400'
              />
              <button className='rounded-r bg-green-500 px-4 text-sm text-white'>
                Verify
              </button>
            </div>
          </div>
          <Input
            label='Website (For Public Display)'
            name='websiteLink'
            value={facilityInformation.facilityContactInformation.websiteLink}
            onChange={handleChange}
          />
          <Input
            label='STD Code'
            name='facilityStdCode'
            value={
              facilityInformation.facilityContactInformation.facilityStdCode
            }
            onChange={handleChange}
          />
          <div className='flex flex-col col-span-1 md:col-span-2'>
            {/* <label className='mb-1 text-sm text-gray-600'>
              Geographic Location
            </label> */}
            <MapRegister />
          </div>
          <Input
            label='Link for book an appointment'
            name='appointmentLink'
            value={
              facilityInformation.facilityContactInformation.appointmentLink
            }
            onChange={handleChange}
          />
        </div>

        <div className='flex flex-col items-center justify-between md:mt-4 md:flex-row'>
          <div className='flex w-full flex-col md:w-[48%]'>
            <span className='text-[14px] italic text-[Gilroy-SemiBold] text-gray-500'>
              How to use:
            </span>
            <span className='text-[14px] text-[Gilroy-SemiBold] text-gray-500'>
              Click on the to enable search. On enabling the field you can
              either choose the current location, or enter the name of the
              location, nearest landmark or select from the results. You can
              then move the map around with location icon being constant in the
              center. Choose confirm and save the coordinates the location of
              the OPD block where you want to patient to reach. Use the
              and-buttons to zoom in and zoom out. Click on Done to
            </span>
          </div>
          <div className='w-[full] md:w-[48%]'>
            <div className='mt-4'>
              <MapWithSearch />
            </div>
          </div>
        </div>

        <div className='mt-8 flex justify-end'>
          <button
            onClick={handleNext}
            className='rounded-full bg-gray-400 px-6 py-2 text-white hover:bg-gray-500'
            disabled={loading}
          >
            {loading ? "Loading..." : "Next"}
          </button>
        </div>
      </Layout>
    </div>
  );
}

HfrRegisterUI.propTypes = {
  setStep: PropTypes.func.isRequired,
  formData: PropTypes.object,
  setFormData: PropTypes.func.isRequired,
};

HfrRegisterUI.defaultProps = {
  formData: {},
};

function Input({ label, name, value, onChange, required }) {
  return (
    <div className='flex flex-col'>
      <label className='mb-1 text-sm text-gray-600'>
        {label} {required && <span className='text-red-500'>*</span>}
      </label>
      <input
        type='text'
        name={name}
        value={value || ""}
        onChange={onChange}
        className='rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
      />
    </div>
  );
}

Input.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
